var exports = {
  "r": "Voted__Epe1Dq",
  "c": "Selected__Ky7aQ1",
};

module.exports = exports;
